import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 泰语
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} สงวนลิขสิทธิ์ทุกประการ',
    },
    auth: {
        login: 'เข้าสู่ระบบ',
        username: 'ชื่อผู้ใช้',
        username_placeholder: 'กรุณาใส่ชื่อผู้ใช้',
        password: 'รหัสผ่าน',
        password_placeholder: 'กรุณาใส่รหัสผ่าน',
        code: 'รหัสยืนยัน',
        code_placeholder: 'กรุณาใส่รหัสยืนยัน',
        logout: 'ออกจากระบบ',
        logout_success: 'ออกจากระบบเรียบร้อยแล้ว',
        day: 'วัน',
        password_expiration: 'รหัสผ่านหมดอายุ – กรุณาเปลี่ยนรหัสผ่าน',
        expire: 'จำนวนวันที่เหลือจนรหัสผ่านหมดอายุ',
        conseils:
            'ต้องประกอบด้วยตัวอักษรพิมพ์ใหญ่ พิมพ์เล็ก ตัวเลข และอักขระพิเศษ ({msg}) ความยาวรหัสผ่านต้องอยู่ระหว่าง 8 ถึง 16 ตัวอักษร',
        brand_Selection: 'เลือกแบรนด์',
        unread_notices: 'ประกาศที่ยังไม่ได้อ่าน',
        new_cases: 'เคสใหม่',
        unanswered_cases: 'เคสที่ยังไม่ได้ตอบกลับ',
        overdue_cases: 'เคสที่เลยกำหนด',
    },
    button: {
        query: 'ค้นหา',
        editing_position: 'แก้ไขตำแหน่ง',
        show_theme_editor: 'แสดง/ซ่อนตัวแก้ไขธีม',
        change_password: 'เปลี่ยนรหัสผ่าน',
        old_password: 'รหัสผ่านเดิม',
        new_password: 'รหัสผ่านใหม่',
        confirm_password: 'ยืนยันรหัสผ่าน',
        button: 'ปุ่ม',
        about: 'เกี่ยวกับ',
        back: 'ย้อนกลับ',
        go: 'ตกลง',
        home: 'หน้าหลัก',
        confirm: 'ยืนยัน',
        modify: 'แก้ไข',
        edit: 'แก้ไข',
        new: 'ใหม่',
        cancel: 'ยกเลิก',
        close: 'ปิด',
        search: 'ค้นหา',
        reset: 'รีเซ็ต',
        delete: 'ลบ',
        add: 'เพิ่ม',
        collapse: 'ยุบ',
        expand: 'ขยาย',
        download_template: 'ดาวน์โหลดเทมเพลต',
        batch_import: 'นำเข้าแบบกลุ่ม',
        import: 'นำเข้า',
        export: 'ส่งออก',
        export_fail: 'การนำเข้าล้มเหลว',
        detailed: 'รายละเอียด',
        details: 'รายละเอียด',
        download: 'ดาวน์โหลด',
        toView: 'ดู',
        toViews: 'ดูรูปภาพ',
        uploadAttachments: 'อัปโหลดไฟล์แนบ',
        selectFile: 'เลือกไฟล์',
        fillingInstructions: 'คำแนะนำการกรอกข้อมูล',
        release: 'เผยแพร่',
        release_recall: 'เรียกคืนการเผยแพร่',
        save: 'บันทึก',
        send: 'ส่ง',
        tips: 'เคล็ดลับ',
        send_back: 'ส่งกลับ',
        examine: 'ตรวจสอบ',
        void: 'ยกเลิก',
        more: 'เพิ่มเติม',
        refresh: 'รีเฟรช',
        selects: 'เลือก',
        serial_number: 'หมายเลขซีเรียล',
        upload_progress: 'ความคืบหน้าการอัปโหลด',
        invalid: 'ไม่ถูกต้อง',
        daily_record: 'บันทึกรายวัน',
        operation_type: 'ประเภทการดำเนินการ',
        field_name: 'ชื่อฟิลด์',
        edit_role: 'แก้ไขบทบาท',
        user_role: 'เลือกบทบาท',
        assignment_role: 'บทบาท',
        post: 'ตำแหน่ง',
        sending: 'กำลังส่ง...',
        reset_password: 'รีเซ็ตรหัสผ่าน',
        display_or_not: 'แสดงหรือไม่',
        document: 'เอกสาร',
        specificTemplates: 'เทมเพลตเฉพาะ',
        transferOrder: 'โอนคำสั่งซื้อ',
        forwarding: 'ส่งต่อ',
        one_click_notification: 'แจ้งเตือนด้วยคลิกเดียว',
        english_export: 'ส่งออกเป็นภาษาอังกฤษ',
        oneclick_download: 'ดาวน์โหลดด้วยคลิกเดียว',
        passwordmsga:
            'ต้องประกอบด้วยตัวอักษรพิมพ์ใหญ่ พิมพ์เล็ก ตัวเลข และอักขระพิเศษ (@\\$!_~\\&*)',
        passwordmsgb: 'ความยาวรหัสผ่านต้องอยู่ระหว่าง 8 ถึง 16 ตัวอักษร',
        passwordmsgc: 'ห้ามซ้ำกับรหัสผ่าน 6 รายการล่าสุด',
        export_file_list: 'รายการไฟล์ที่ส่งออก',
        personal_center: 'ศูนย์ส่วนตัว',
        upload_list: 'รายการอัปโหลด',
        clear_completed: 'ล้างรายการที่เสร็จสิ้น',
    },
    radio: {
        enabled: 'เปิดใช้งาน',
        disabled: 'ปิดใช้งาน',
        catalogue: 'แคตตาล็อก',
        individual: 'รายบุคคล',
        all: 'ทั้งหมด',
        yes: 'ใช่',
        no: 'ไม่',
    },
    dropdown: {
        close_others: 'ปิดอื่นๆ',
        close_right: 'ปิดด้านขวา',
        close_left: 'ปิดด้านซ้าย',
    },
    table: {
        action: 'การดำเนินการ',
        explain: 'คำอธิบาย',
        fileName: 'ชื่อไฟล์',
        size: 'ขนาด (MB)',
        uploader: 'ผู้อัปโหลด',
        uploadTime: 'วันที่อัปโหลด',
        system: 'ระบบ',
        caption: 'คำบรรยาย',
        categorization: 'การจัดหมวดหมู่',
        link: 'ลิงก์',
        forwarding_time: 'วันที่ส่งต่อ',
        forwarder: 'ผู้ส่งต่อ',
        send_to: 'ส่งถึง',
        mode: 'โหมด',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `หน้า ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `ทั้งหมด ${named('number')} รายการ`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `ทั้งหมด ${named('number')} คัน`,
    },
    confirm: {
        confirm_deletion: 'ยืนยันการลบ?',
        confirm_void: 'ยืนยันการยกเลิก?',
        confirm_release: 'ยืนยันการเผยแพร่?',
        ack: 'ยืนยัน',
        cancel: 'ยกเลิก',
        non_records: 'กรุณาเลือกอย่างน้อย 1 รายการ',
    },
    request: {
        failed_placeholder: 'คำขอไม่สำเร็จ – เกิดข้อผิดพลาดของเซิร์ฟเวอร์',
        success_placeholder: 'คำขอสำเร็จ',
        auth: {
            login_success: 'เข้าสู่ระบบสำเร็จ',
        },
        error: {
            '404': 'ไม่พบเส้นทางที่ร้องขอ',
            '403': 'สิทธิ์ไม่เพียงพอ',
        },
    },
    page: {
        global: {
            page_search: 'ค้นหาในหน้านี้',
        },
        error: {
            not_found: 'ไม่พบหน้านี้',
            not_found_des: 'ไม่มีอะไรอยู่ที่นี่',
            auth_failed: 'สิทธิ์ไม่เพียงพอ',
            auth_failed_des: 'หน้านี้ถูกจำกัดการเข้าถึง',
            file_format_error: 'รูปแบบไฟล์ไม่ถูกต้อง!',
            preview_failed: 'แสดงตัวอย่างไม่ได้! ไฟล์เสียหาย!',
        },
        homepage: {
            homepage: homepage.homepage.thTH,
        },
        system: {
            menu: system.menu.thTH,
            dict: system.dict.thTH,
            dept: system.dept.thTH,
            role: system.role.thTH,
            user: system.user.thTH,
        },
        info: {
            announcement: Info.announcement.announcement.thTH,
            document: Info.document.document.thTH,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.thTH,
                recallActivity: tech.quality.recallActivity.thTH,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.thTH,
            },
            management: {
                inquiryOd: tech.management.inquiry.thTH,
                permission: tech.management.permission.thTH,
                onSiteSupportHq: tech.management.onSiteSupport.thTH,
                progHistoryHq: tech.management.progHistory.thTH,
                salesRecordHq: tech.management.salesRecord.thTH,
                vehicleInfoHq: tech.management.vehicleInfo.thTH,
                claimHq: tech.management.claim.thTH,
                filterHq: tech.management.filter.thTH,
                newCarlssue: tech.management.newCarIssue.thTH,
                newCarDefinition: tech.management.newCarDefinition.thTH,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.thTH,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.thTH,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.thTH,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.thTH,
        },
        statistics: statistics.inquiryStatistics.thTH,
        systemClassifyA: statistics.systemClassifyA.thTH,
        systemClassifyB: statistics.systemClassifyB.thTH,
        engineerStatistics: statistics.engineerStatistics.thTH,
        defectivePart: statistics.defectivePart.thTH,
        replyInquiryStatistics: statistics.replyInquiryStatistics.thTH,
        passRateStatistics: statistics.passRateStatistics.thTH,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.thTH,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.thTH,
        customsClearance135Rate: statistics.customsClearance135Rate.thTH,
        accumulatedClosureRate: statistics.accumulatedClosureRate.thTH,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.thTH,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.thTH,
    },
    validation: {
        common: {
            required: 'ช่องนี้จำเป็นต้องกรอก',
            numeric: 'ต้องเป็นจำนวนเต็ม',
            decimal: 'ต้องเป็นตัวเลข',
            positive_interger: 'ต้องเป็นจำนวนเต็มบวก',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `สูงสุด ${named('number')} หลัก`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `ต้องไม่เกิน ${named('number')} ตัวอักษร`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `เกินจำนวนอักขระสูงสุดที่อนุญาต (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `ต้องมีอย่างน้อย ${named('number')} ตัวอักษร`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `ต้องมี ${named('number')} ตัวอักษรพอดี`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `ต้องไม่เกิน ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `ต้องไม่น้อยกว่า ${named('number')}`,
            up_to_2_decimal_places: 'ทศนิยมได้สูงสุด 2 ตำแหน่ง',
            retain_up: 'ได้สูงสุด 10 หลักก่อนจุดทศนิยม และ 2 หลังจุดทศนิยม',
            retain_ups: 'ได้สูงสุด 11 หลักก่อนจุดทศนิยม และ 4 หลังจุดทศนิยม',
            input_number: 'กรุณาใส่เฉพาะตัวเลขอาหรับ',
            only_number_a: 'อนุญาตเฉพาะตัวอักษรหรือตัวเลข',
            translate: 'อนุญาตเฉพาะตัวอักษร',
            positive_integer: 'กรุณากรอกอย่างน้อยหนึ่งช่อง',
            at_least_one: 'กรุณากรอกอย่างน้อยหนึ่งรายการ',
        },
        tip: {
            incomplete_information: 'ข้อมูลไม่สมบูรณ์',
        },
    },
    import: {
        template_file: 'ไฟล์เทมเพลต',
        browse: 'เรียกดู',
        download_template: 'ดาวน์โหลดเทมเพลต',
        no_file_selected: 'ยังไม่ได้เลือกไฟล์',
        incorrect_file_type: 'ประเภทไฟล์ไม่ถูกต้อง',
        exceed: 'เกินขีดจำกัด',
        upload_success: 'อัปโหลดสำเร็จ',
        upload_fail: 'อัปโหลดไม่สำเร็จ',
        again_upload:
            'รองรับเฉพาะไฟล์รูปภาพรูปแบบ jpg, png, bmp หรือ gif เท่านั้น กรุณาลองอีกครั้ง',
        attachmentUpload: 'อัปโหลดไฟล์แนบ',
        otherAttachmentUpload: 'อัปโหลดไฟล์แนบอื่นๆ',
        supportedFormats: 'รูปแบบที่รองรับ',
        preview: 'ดูตัวอย่าง',
    },
    export: {
        noDataToExport: 'ไม่มีข้อมูลให้ส่งออก',
    },
    select: {
        all: 'ทั้งหมด',
    },
    checkbox: {
        select_all: 'เลือกทั้งหมด',
    },
    dialog: {
        error_message: 'ข้อความแสดงข้อผิดพลาด',
        one_year: 'สามารถส่งออกข้อมูลได้สูงสุด 1 ปีต่อครั้ง',
    },
    ymd: {
        year: 'ปี',
        month: 'เดือน',
        day: 'วัน',
        week: 'สัปดาห์',
        january: 'มกราคม',
        february: 'กุมภาพันธ์',
        march: 'มีนาคม',
        april: 'เมษายน',
        may: 'พฤษภาคม',
        june: 'มิถุนายน',
        july: 'กรกฎาคม',
        august: 'สิงหาคม',
        september: 'กันยายน',
        october: 'ตุลาคม',
        november: 'พฤศจิกายน',
        december: 'ธันวาคม',
    },
};
